import { SxProps, Theme } from '@mui/material';

import { Color } from 'shared/utils/colors';

import {
  DOCUMENTATION_BROWSER_LIST_HEIGHT,
  DOCUMENTATION_BROWSER_MAX_WIDTH,
} from './constants';

export const dialogPaperSx: SxProps<Theme> = {
  maxWidth: DOCUMENTATION_BROWSER_MAX_WIDTH,
};

export const dialogTitleSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const dialogContentSx: SxProps<Theme> = {
  p: 0,
  overflow: 'hidden',
  pt: 2,
};

export const searchBoxSx: SxProps<Theme> = {
  px: 3,
  pb: 2,
  width: '100%',
  boxSizing: 'border-box',
  minWidth: 0,
  '& > div': { width: '100%', minWidth: 0 },
  '& > div > div': { width: '100%', minWidth: 0, maxWidth: '100%' },
  '& input': { width: '100%', boxSizing: 'border-box' },
};

export const listWrapperSx: SxProps<Theme> = {
  overflow: 'hidden',
  minWidth: 0,
};

export const actionsBoxSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  px: 3,
  pt: 2,
  pb: 3,
  gap: 1,
};

export const actionsLeftSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
};

export const listContainerSx: SxProps<Theme> = {
  height: DOCUMENTATION_BROWSER_LIST_HEIGHT,
  overflowY: 'auto',
  overflowX: 'hidden',
  minWidth: 0,
  py: 0,
};

export const listLoadingBoxSx: SxProps<Theme> = {
  height: DOCUMENTATION_BROWSER_LIST_HEIGHT,
  overflowY: 'auto',
};

export const listEmptyMessageSx: SxProps<Theme> = {
  py: 2,
  px: 1,
  textAlign: 'center',
  color: 'text.secondary',
};

export const listEmptyBoxSx: SxProps<Theme> = {
  height: DOCUMENTATION_BROWSER_LIST_HEIGHT,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};

export const listItemSelectedSx: SxProps<Theme> = {
  '&.Mui-selected': {
    bgcolor: Color.primaryOrange,
    '&:hover': { bgcolor: Color.primaryOrange },
  },
  '&:hover': { bgcolor: Color.solidGray },
};

export const listItemIconSx: SxProps<Theme> = {
  minWidth: 40,
};

export const directoryPrimaryTypographySx = (
  selected: boolean
): SxProps<Theme> => ({
  fontWeight: selected ? 500 : 400,
  color: Color.black,
  fontSize: 14,
});

export const documentationPrimaryTypographySx = (
  selected: boolean
): SxProps<Theme> => {
  return {
    fontWeight: selected ? 500 : 400,
    color: Color.black,
    fontSize: 14,
  };
};

export function getListItemBorderSx(theme: Theme): SxProps<Theme> {
  return { borderBottom: `1px solid ${theme.palette.divider}` };
}

export function getDirectoryButtonDisabledSx(theme: Theme): SxProps<Theme> {
  return {
    opacity: 0.7,
    cursor: 'wait',
    '&.Mui-disabled': {
      color: theme.palette.text.secondary,
    },
  };
}

export function getDocumentationButtonSx(): SxProps<Theme> {
  return {
    py: 1.5,
    px: 3,
    cursor: 'default',
  };
}

export function getChevronSx(theme: Theme): SxProps<Theme> {
  return { color: theme.palette.text.secondary, fontSize: 24 };
}

export const directoryButtonBaseSx: SxProps<Theme> = {
  py: 1.5,
  px: 3,
};
